module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-12.bc564804.svg";